import { twMerge } from "tailwind-merge";

import { Skeleton } from "@/components/skeletons/Skeleton";
import { Heading4 } from "@/components/text/Heading4";

export function AudioOutputSkeleton({ size }: { size: "medium" | "small" }) {
  const skeletonHeight = size === "medium" ? "h-[88px]" : "h-[56px]";

  return (
    <div className="flex flex-col gap-y-4">
      <Skeleton className={twMerge(skeletonHeight, "w-full rounded-2xl")} />
      <Heading4 elementType="h2" className="mt-2">
        History
      </Heading4>
      <Skeleton className={twMerge(skeletonHeight, "w-full rounded-2xl")} />
      <Skeleton className={twMerge(skeletonHeight, "w-full rounded-2xl")} />
    </div>
  );
}
